import api from "../apiConfig";
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/salary-history?${p}`);
  },
  getById(id) {
    return api.get(`/api/v1/salary-history/${id}`);
  },
  update(data) {
    return api.put(`/api/v1/salary-history/${data.id}`, data);
  },
  create(data) {
    return api.post(`/api/v1/salary-history`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/salary-history/${id}`);
  },
  changeStatus(id) {
    return api.put(`/api/v1/salary-history/status/${id}`);
  },
  changeStatusWithInfo(data) {
    return api.put(`/api/v1/salary-history/${data.id}`, data);
  },
};
